// const base_url =
//   'https://j5cf2ek4r5.execute-api.eu-west-1.amazonaws.com/default';
const env = process.env.REACT_APP_ENV;
const base_url = `https://api.${env}.baltee-tech.com`; 

export async function loginAPI(mail, pass) {
  const url = base_url + '/auth/login';

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  var raw = JSON.stringify({
    username: mail.toLowerCase(),
    password: pass,
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  const response = await fetch(url, requestOptions);
  const json = await response.json();
  return json;
}

export async function refreshLoginAPI(refreshToken) {
  const url = base_url + '/auth/accesstoken';

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  var raw = JSON.stringify({
    RefreshToken: refreshToken,
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  const response = await fetch(url, requestOptions);
  const json = await response.json();
  return json;
}

export async function signUpAPI(data) {
  const url = base_url + '/user';

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  const response = await fetch(url, requestOptions);

  // console.log('signup res : ', response);
  const json = await response.json();
  return json;
}

export async function resetPasswordAPI(mail) {
  const url = base_url + '/auth/resetpassword';

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  var raw = JSON.stringify({
    mail: mail.toLowerCase(),
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  const response = await fetch(url, requestOptions);
  const json = await response.json();

  return json;
}

export async function confirmPasswordCodeAPI(data) {
  const url = base_url + '/auth/confirmcode';

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  var raw = JSON.stringify({
    mail: data.mail.toLowerCase(),
    password: data.password,
    confirmationCode: data.confirmationCode,
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  const response = await fetch(url, requestOptions);
  const json = await response.json();

  return json;
}

export async function resetMailAPI(token, mail) {
  const url = base_url + '/auth/resetmail';

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', token);

  var raw = JSON.stringify({
    mail: mail.toLowerCase(),
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200 || response.status === 201) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function logoutAPI(refreshToken) {
  const url = base_url + '/auth/logout';

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  var raw = JSON.stringify({
    RefreshToken: refreshToken,
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  try {
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error('Erreur lors de la déconnexion.');
    }

    const json = await response.json();
    return json; // Renvoie la réponse du serveur après déconnexion
  } catch (error) {
    console.error('Erreur lors de la déconnexion:', error);
    return { success: false, message: error.message }; // Gestion des erreurs
  }
}

